import script from "./DecorationBottomMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationBottomMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationBottomMenu.vue?vue&type=style&index=0&id=466f9dae&lang=css"

const __exports__ = script;

export default __exports__